/**
 * @module app.EmbedService
 */
import appBase from './index.js';

export default class EmbedService {
  /**
   * @param {!angular.$httpParamSerializer} $httpParamSerializer
   * @ngInject
   */
  constructor($httpParamSerializer) {

    /**
     * @private
     */
    this.httpParamSerializer_ = $httpParamSerializer;
  }

  /**
   * @return {string}
   */
  getEmbeddedFullUrl() {
    // Remove params related to embedded mode
    const keysToRemove = new Set(['embed', 'onlyRoute', 'noNavigation']);
    const searchEntries = window.location.search.slice(1).split('&');
    const queryParams = {};
    searchEntries.forEach((entry) => {
      const [key, value] = entry.split('=');
      if (!keysToRemove.has(key)) {
        queryParams[key] = value;
      }
    });
    const queryString = this.httpParamSerializer_(queryParams);
    return `${window.location.pathname}?${queryString}`;
  }
}

appBase.service('appEmbedService', EmbedService);
